import PropTypes from 'prop-types'
import preventDefault from 'prevent-default'

import { noop } from 'utils'
import Button from 'components/form/Button'
import NoneAnchor from '../NoneAnchor'
import Tooltip from 'components/tooltip/Tooltip'

export const ConfirmModal = ({
  title,
  handleClose,
  onConfirm = noop,
  confirmText = '확인',
  confirmDisabled = false,
  onCancel = noop,
  showCancelBtn = true,
  children,
  footer,
}) => {
  const shouldShowHeader = !!title
  const hasButtons = onCancel || onConfirm
  const handleCancel = async () => {
    let shouldClose = true
    await onCancel({
      preventClose: () => {
        shouldClose = false
      },
    })
    if (shouldClose) handleClose()
  }
  const handleConfirm = async () => {
    if (!confirmDisabled) {
      let shouldClose = true
      await onConfirm({
        preventClose: () => {
          shouldClose = false
        },
      })
      if (shouldClose) handleClose()
    }
  }

  return (
    <>
      {shouldShowHeader && (
        <div className="layer_head">
          {title && <strong className="tit_layer">{title}</strong>}
        </div>
      )}

      <div className="layer_body">{children}</div>

      {hasButtons && (
        <div className="layer_foot">
          {footer}
          <div className="btn_group">
            {showCancelBtn && onCancel && (
              <NoneAnchor onClick={handleCancel} className="btn_gm">
                <span className="inner_g">취소</span>
              </NoneAnchor>
            )}

            {onConfirm && (
              <Button
                onClick={preventDefault(handleConfirm)}
                primary
                disabled={confirmDisabled}>
                {confirmText}
              </Button>
            )}
          </div>

          <NoneAnchor onClick={handleCancel} className="btn_close">
            <span className="ico_comm ico_close">닫기</span>
          </NoneAnchor>
        </div>
      )}
    </>
  )
}

ConfirmModal.propTypes = {
  children: PropTypes.node,
  handleClose: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  title: PropTypes.node,
  confirmText: PropTypes.string,
  confirmDisabled: PropTypes.bool,
  showCancelBtn: PropTypes.bool,
  footer: PropTypes.node,
}

export const PreviewConfirmModal = ({
  title,
  handleClose,
  isSubmitting,
  onConfirm = noop,
  confirmDisabled = false,
  onPreview = noop,
  previewDisabled = false,
  onCancel = noop,
  children,
}) => {
  const shouldShowHeader = !!title
  const hasButtons = onCancel || onPreview || onConfirm
  const handleCancel = async () => {
    let shouldClose = true
    await onCancel({
      preventClose: () => {
        shouldClose = false
      },
    })
    if (shouldClose) handleClose()
  }
  const handleConfirm = async () => {
    let shouldClose = true
    await onConfirm({
      preventClose: () => {
        shouldClose = false
      },
    })
    if (shouldClose) handleClose()
  }

  return (
    <>
      {shouldShowHeader && (
        <div className="layer_head">
          {title && <strong className="tit_layer">{title}</strong>}
        </div>
      )}
      <div className="layer_body">{children}</div>
      {hasButtons && (
        <div className="layer_foot">
          <div className="btn_group">
            <NoneAnchor onClick={handleCancel} className="btn_gm">
              <span className="inner_g">취소</span>
            </NoneAnchor>
            <Button
              line
              onClick={preventDefault(onPreview)}
              disabled={previewDisabled}>
              미리보기
            </Button>
            {confirmDisabled ? (
              <Tooltip
                tag="button"
                content="미리보기 후 확인(저장) 가능합니다."
                position="alignRight bottom"
                offsetY={5}
                wrapperClassName="btn_gm gm_bl in_active"
                style={{ pointerEvents: 'auto' }}>
                <span className="inner_g">확인</span>
              </Tooltip>
            ) : (
              <Button
                primary
                onClick={preventDefault(handleConfirm)}
                loading={isSubmitting}>
                확인
              </Button>
            )}
          </div>
          <NoneAnchor onClick={handleCancel} className="btn_close">
            <span className="ico_comm ico_close">닫기</span>
          </NoneAnchor>
        </div>
      )}
    </>
  )
}

PreviewConfirmModal.propTypes = {
  children: PropTypes.node,
  handleClose: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  title: PropTypes.node,
  confirmText: PropTypes.string,
  confirmDisabled: PropTypes.bool,
  onPreview: PropTypes.func,
  previewDisabled: PropTypes.bool,
}
